import styled from 'styled-components';
import { padding, paddingLeft, paddingRight, pxToRem, unit } from 'modules/v2/foundation/spacing';
import { themeGet, themeGetColor } from 'modules/v2/foundation/theme';
export const Container = styled.div `
  display: ${(props) => (props.$stretch ? 'flex' : 'inline-flex')};
  justify-content: center;
`;
export const Dot = styled.div `
  position: relative;
  padding: 0;
  background-color: ${themeGet('colors.gray.200')};
  border: 0;

  button:focus-visible > & {
    box-shadow: ${(props) => (props.$selected ? `0 0 0 ${pxToRem(2)} ${themeGetColor('gray.700', 0.2)}` : 'none')};
  }

  &,
  &:before {
    width: ${unit(2)};
    height: ${unit(2)};
    border-radius: ${themeGet('borderRadius.circle')};
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background-color: ${(props) => (props.$selected ? themeGet('colors.primary.500') : 'transparent')};
  }
`;
export const StyledButton = styled.button `
  ${padding(1)};
  appearance: none;
  background-color: transparent;
  border: 0;

  &:first-child {
    ${paddingLeft(0)}
  }

  &:last-child {
    ${paddingRight(0)}
  }

  &:focus-visible {
    outline: none;
  }
`;
